import React, { useContext, useEffect, useState } from 'react';
import { DataLayerEventContext } from '../contexts/dataLayerEventContext';
import MenuScreen from '../common/menu-screen';
import ProhibitedChapterScreen from '../common/prohibited-chapter-screen';
import InfoScreen from '../components/lm-d-s/info-screen';
import CharacteristicScreen from '../components/lm-d-s/characteristic-screen';
import FourOptionsChallenge from '../common/challenge-component/four-options-challenge';
import PredictionScreen from '../common/prediction-screen';
import ResultInfoScreen from '../common/challenge-component/result-info-screen';
import FinalScreen from '../components/lm-d-s/final-screen';
import LmLineScreen from '../components/lm-d-s/lm-line-screen';
import SelectSeasonChallenge from '../common/challenge-component/select-season-challenge';
import AuthorityScreen from '../common/authority-screen';
import BrandLineScreen from '../common/brand-line-screen';
import ErrorScreen from '../components/lm-d-s/errorScreen';
import styles from '../components/lm-d-s/index.module.scss';
import { ScreensContext } from '../contexts/screensContext';
import CommerceVideoScreen from '../components/commerce-video-screen/CommerceVideoScreen';
import AllBrandsScreen from '../common/all-brands-screen';
import { getImageFromS3 } from '../imageService';
import ReviewFlowScreen from '../common/review-flow-screen';
import {
  trueFalseArtChallengeList,
  trueFalseArtResultList
} from '../consts/soho-facts-challenge';
import { CURRENT_CHALLENGE_NAME } from '../consts/challengeName';
import TrueFalseArtChallenge from '../common/challenge-component/true-false-art-challenge';
import useScreenHistory from '../hooks/useScreenHistory';

const menu = [
  {
    id: 'challenge',
    screenNumber: 8,
    name: CURRENT_CHALLENGE_NAME,
    icon: 'images/lm-double-splash/may-challenge-menu-icon.svg'
  },
  {
    id: 'foresight',
    screenNumber: 6,
    name: 'Передбачення на сьогодні',
    icon: 'images/lm-double-splash/foresight-menu-icon.svg'
  },
  {
    id: 'characteristic',
    screenNumber: 4,
    name: 'Характеристики сигарет',
    icon: 'images/lm-double-splash/characteristic-menu-icon.svg'
  },
  {
    id: 'info',
    screenNumber: 3,
    name: 'Все про Філіп Морріс Україна',
    icon: 'images/lm-double-splash/info-menu-icon.svg'
  },
  {
    id: 'difference',
    screenNumber: 15,
    name: 'Як відрізнити підробку від оригіналу?',
    icon: 'images/common/menu-icon/authority-menu-icon.svg'
  },
  {
    id: 'review',
    screenNumber: 12,
    name: 'Залишити відгук про продукт',
    icon: 'images/lm-double-splash/review-menu-icon.svg'
  }
];

const selectedPack = {
  title: 'Parliament Soho Silver Super Slims',
  pack: getImageFromS3('images/packs/parliament/soho-silver-super-slims.png'),
  tobaccoFirst: 'Вміст смол, мг - 3',
  tobaccoSecond: 'Вміст нікотину, мг - 0.3',
  filterIcon: getImageFromS3('images/parliament/filter.png'),
  background: `url("${getImageFromS3('images/parliament/bg.png')}")`,
  characteristicInfoList: [
    {
      title: 'Формат ',
      description: '- 100 Super Slims ("100 супер слімc")'
    },
    {
      title: 'Кількість сигарет у пачці ',
      description: '– 20'
    },
    {
      title: 'Кількість пачок у блоці ',
      description: '– 10'
    }
  ],
  characteristicListTitle: (
    <div>
      <p>
        Оригінальний Recessed<sup>тм</sup> фільтр
      </p>
      <p>
        Фільтр складається з 3-x <br /> частин:
      </p>
    </div>
  ),
  filterCharacteristicList: [
    {
      description: <span>Ацетатна частина</span>,
      bordered: true
    },
    {
      description: <span>Вугільна частина</span>,
      bordered: true
    },
    {
      description: (
        <span>
          Ущільнена повітряна камера з ацетатною стінкою, що робить смак м'яким
          і більш збалансованим
        </span>
      ),
      bordered: true
    }
  ]
};

const partners = {
  rozetka: 'https://rozetka.com.ua/ua/sigareti/c4638591/producer=parliament/',
  cigPoshta: 'https://cig-poshta.in.ua/shop/parliament/?utm_source=SP'
};

const PRLShSSSL = ({ setAppNumber }) => {
  const toReviewButton = sessionStorage.getItem('r_b') === 'true';
  const { screenNumber, setScreenNumber, historyState, updateHistoryState } =
    useScreenHistory({
      initialScreen: toReviewButton ? 12 : 0,
      initialState: { brandLine: '' }
    });
  const brandLine = historyState.brandLine || '';
  const [endSessionType, setEndSessionType] = useState('SESSION_END');
  const [isDisplayedAll, setIsDisplayedAll] = useState(false);
  const { init, sendEvent } = useContext(DataLayerEventContext);

  useEffect(() => {
    init('PRL-Sh-S-SSL');
    sendEvent('age_verification_without');
  }, [init]);

  const getScreen = (number, cb) => {
    switch (number) {
      case -1: {
        return (
          <AllBrandsScreen
            setScreenNumber={cb}
            setBrandLine={(brand) => {
              setScreenNumber(16, false, { brandLine: brand });
            }}
            handleBackButton={() => setScreenNumber(1, true)}
            historyState={historyState}
            updateHistoryState={updateHistoryState}
          />
        );
      }
      case 0: {
        return (
          <CommerceVideoScreen
            videoSrc={getImageFromS3('videos/soho-super-slims.mp4')}
            setScreenNumber={setScreenNumber}
            nextScreenNumber={1}
            changeScreenImmediately
            buttonStyle="skip-video"
            skipButtonBottomPosition={45}
            skipScreenImmediately
            controls
          />
        );
      }
      case 1: {
        return (
          <MenuScreen
            setScreenNumber={cb}
            menuList={menu}
            backgroundImage={`url("${getImageFromS3(
              'images/parliament/bg.png'
            )}")`}
          />
        );
      }
      case 2: {
        return (
          <ProhibitedChapterScreen
            setScreenNumber={cb}
            setReviewScreenNumber={() => setScreenNumber(12)}
          />
        );
      }
      case 3: {
        return (
          <InfoScreen
            setScreenNumber={cb}
            setReviewScreenNumber={() => setScreenNumber(10)}
          />
        );
      }
      case 4: {
        return (
          <CharacteristicScreen
            brandId="25UA-PRL-Sh-S-SSL"
            isNewMixture={selectedPack?.isNewMixture}
            title={selectedPack?.title}
            setScreenNumber={setScreenNumber}
            filterCharacteristicList={selectedPack?.filterCharacteristicList}
            characteristicListTitle={selectedPack?.characteristicListTitle}
            infoList={selectedPack?.characteristicInfoList}
            tobaccoFirst={selectedPack?.tobaccoFirst}
            tobaccoSecond={selectedPack?.tobaccoSecond}
            packImage={selectedPack?.pack}
            handleBackButton={() => setScreenNumber(1, true)}
            handleNextButton={() => setScreenNumber(10)}
            fullRangeButtonClick={() => setScreenNumber(-1)}
            backgroundImage={selectedPack?.background}
            filterIcon={selectedPack?.filterIcon}
            nextButtonTitle="Далі"
          />
        );
      }
      case 5: {
        return (
          <FourOptionsChallenge
            setScreenNumber={setScreenNumber}
            type="default"
            backgroundImage={`url("${getImageFromS3(
              'images/parliament/bg.png'
            )}")`}
          />
        );
      }
      case 6: {
        return (
          <PredictionScreen
            setScreenNumber={setScreenNumber}
            handleBackButton={() => setScreenNumber(1, true)}
          />
        );
      }
      case 7: {
        return (
          <ResultInfoScreen
            setScreenNumber={setScreenNumber}
            setNextScreenNumber={() => setScreenNumber(10)}
            title="Сподіваємося"
            subtitle="тобі було цікаво"
            description="Дослухайся до наших порад і зроби зустріч із друзями незабутньою!"
            image={getImageFromS3(
              'images/lm-double-splash/challenge/september-challenge/finally-icon.png'
            )}
            backgroundImage={`url("${getImageFromS3(
              'images/parliament/bg.png'
            )}")`}
          />
        );
      }
      case 8: {
        return (
          <TrueFalseArtChallenge
            setScreenNumber={cb}
            challengeList={trueFalseArtChallengeList}
            backgroundImage={`url("${getImageFromS3(
              '/images/parliament/bg.png'
            )}")`}
            resultList={trueFalseArtResultList}
            setAfterResultScreen={() => setScreenNumber(10)}
          />
          // <RepresentativeOfSubcultureChallenge
          //   setScreenNumber={cb}
          //   challengeList={representativeOfSubcultureChallengeList}
          //   backgroundImage={`url("${getImageFromS3(
          //     'images/percentage-of-your-bohemian-challenge/background.png'
          //   )}")`}
          //   resultList={representativeOfSubcultureResultList}
          //   setAfterResultScreen={() => setScreenNumber(10)}
          // />
          // <PercentageOfYourBohemianChallenge
          //   setScreenNumber={cb}
          //   challengeList={percentageOfYourBohemianChallenge}
          //   backgroundImage={`url("${getImageFromS3(
          //     'images/percentage-of-your-bohemian-challenge/background.png'
          //   )}")`}
          //   resultList={percentageOfYourBohemianResultList}
          //   setAfterResultScreen={() => setScreenNumber(10)}
          // />
        );
      }
      case 10: {
        return <FinalScreen setScreenNumber={cb} withReviewButton />;
      }
      case 11: {
        return <FinalScreen setScreenNumber={cb} />;
      }
      case 12: {
        return (
          <ReviewFlowScreen
            setScreenNumber={cb}
            setSubmitReviewScreenNumber={() => setScreenNumber(11)}
            innerScreenNumber={historyState.innerScreenNumber}
            setInnerScreenNumber={(val) =>
              setScreenNumber(12, false, { innerScreenNumber: val })
            }
          />
        );
      }
      case 13: {
        return <LmLineScreen setScreenNumber={cb} />;
      }
      case 14: {
        return (
          <SelectSeasonChallenge
            backgroundImage={`url("${getImageFromS3(
              'images/parliament/bg.png'
            )}")`}
            setScreenNumber={setScreenNumber}
            type="harmony_in_self-knowledge-lm"
            style="soho"
            setNextScreenNumber={() => setScreenNumber(10)}
          />
        );
      }
      case 15: {
        return (
          <AuthorityScreen
            partners={partners}
            setScreenNumber={cb}
            setReviewScreenNumber={() => setScreenNumber(10)}
          />
        );
      }
      case 16: {
        return (
          <BrandLineScreen
            brandId={brandLine}
            setScreenNumber={setScreenNumber}
            backButtonClick={() => setScreenNumber(-1, true)}
            nextButtonClick={() => setScreenNumber(10)}
            historyState={historyState}
            updateHistoryState={updateHistoryState}
          />
        );
      }
      default: {
        return <ErrorScreen setScreenNumber={cb} />;
      }
    }
  };

  return (
    <div className={styles.pageContainer} id="new-parliament-screen-container">
      <div className={styles.contentContainer}>
        <ScreensContext.Provider
          value={{
            endSessionType,
            setEndSessionType,
            isDisplayedAll,
            setIsDisplayedAll
          }}
        >
          {getScreen(screenNumber, setScreenNumber)}
        </ScreensContext.Provider>
      </div>
    </div>
  );
};

export default PRLShSSSL;
